var map = {
	"./images/banners/banner-bg-left.svg": 9704,
	"./images/banners/banner-bg-m.png": 9177,
	"./images/banners/banner-bg-right.svg": 7334,
	"./images/banners/banner-bg-support-savings-m.png": 2095,
	"./images/banners/banner-bg-support-savings.png": 8400,
	"./images/banners/banner-bg.png": 5270,
	"./images/banners/banner-bg.svg": 89,
	"./images/cta-cards/img-annette-story-m.png": 8914,
	"./images/cta-cards/img-annette-story-m.webp": 5338,
	"./images/cta-cards/img-annette-story.png": 7662,
	"./images/cta-cards/img-annette-story.webp": 8635,
	"./images/cta-cards/img-events-near-you-m.png": 2559,
	"./images/cta-cards/img-events-near-you-m.webp": 5015,
	"./images/cta-cards/img-events-near-you.png": 4852,
	"./images/cta-cards/img-events-near-you.webp": 5366,
	"./images/cta-cards/img-get-questions.png": 3378,
	"./images/cta-cards/img-get-questions.webp": 9993,
	"./images/cta-cards/img-get-the-kit-m.png": 6309,
	"./images/cta-cards/img-get-the-kit-m.webp": 3167,
	"./images/cta-cards/img-get-the-kit.png": 3815,
	"./images/cta-cards/img-get-the-kit.webp": 9171,
	"./images/cta-cards/img-get-tips.png": 6830,
	"./images/cta-cards/img-get-tips.webp": 3626,
	"./images/cta-cards/img-see-faqs.png": 9425,
	"./images/cta-cards/img-see-faqs.webp": 8337,
	"./images/cta-cards/img-see-savings-m.png": 7107,
	"./images/cta-cards/img-see-savings-m.webp": 6950,
	"./images/cta-cards/img-see-savings.png": 7001,
	"./images/cta-cards/img-see-savings.webp": 9189,
	"./images/cta-cards/img-watch-now-m.png": 5220,
	"./images/cta-cards/img-watch-now-m.webp": 7619,
	"./images/cta-cards/img-watch-now.png": 5778,
	"./images/cta-cards/img-watch-now.webp": 2224,
	"./images/cta-cards/overlay-annette-story-m.svg": 2294,
	"./images/cta-cards/overlay-annette-story.svg": 3429,
	"./images/cta-cards/overlay-events-near-you-m.svg": 7169,
	"./images/cta-cards/overlay-events-near-you.svg": 6812,
	"./images/cta-cards/shapes-annette-story-m.svg": 1017,
	"./images/cta-cards/shapes-annette-story.svg": 5562,
	"./images/header/banner-patient-support-bg.svg": 6851,
	"./images/home-heroes/bg-img-discover-the-difference-m.png": 5444,
	"./images/home-heroes/bg-img-discover-the-difference-m.webp": 8310,
	"./images/home-heroes/bg-img-discover-the-difference.png": 3154,
	"./images/home-heroes/bg-img-discover-the-difference.webp": 9416,
	"./images/home-heroes/bg-img-see-whats-new-m.png": 701,
	"./images/home-heroes/bg-img-see-whats-new-m.webp": 5065,
	"./images/home-heroes/bg-img-see-whats-new.png": 2594,
	"./images/home-heroes/bg-img-see-whats-new.webp": 7647,
	"./images/home-heroes/bg-img-start-saving-m.png": 8241,
	"./images/home-heroes/bg-img-start-saving-m.webp": 1798,
	"./images/home-heroes/bg-img-start-saving.png": 8007,
	"./images/home-heroes/bg-img-start-saving.webp": 771,
	"./images/home-heroes/bg-img-watch-now-m.png": 2916,
	"./images/home-heroes/bg-img-watch-now-m.webp": 5738,
	"./images/home-heroes/bg-img-watch-now.png": 1606,
	"./images/home-heroes/bg-img-watch-now.webp": 6783,
	"./images/home-heroes/bg-shapes-discover-the-difference-m.png": 7374,
	"./images/home-heroes/bg-shapes-discover-the-difference-m.svg": 6130,
	"./images/home-heroes/bg-shapes-discover-the-difference.svg": 2163,
	"./images/home-heroes/bg-shapes-see-whats-new-m.svg": 4081,
	"./images/home-heroes/bg-shapes-see-whats-new.svg": 7646,
	"./images/home-heroes/bg-shapes-start-saving-m.svg": 8894,
	"./images/home-heroes/bg-shapes-start-saving.svg": 2965,
	"./images/home-heroes/overlay-see-whats-new-m.svg": 1470,
	"./images/home-heroes/overlay-see-whats-new.svg": 6584,
	"./images/home-heroes/overlay-start-saving-m.png": 1517,
	"./images/home-heroes/overlay-start-saving-m.svg": 1483,
	"./images/home-heroes/overlay-start-saving.png": 2783,
	"./images/home-heroes/overlay-start-saving.svg": 4273,
	"./images/home-heroes/overlay-watch-now-m.svg": 5362,
	"./images/home-heroes/overlay-watch-now.svg": 2345,
	"./images/icons/icon-arrow-down-blue.svg": 5851,
	"./images/icons/icon-arrow-down-disco.svg": 947,
	"./images/icons/icon-arrow-up-blue.svg": 1273,
	"./images/icons/icon-arrow-up-disco.svg": 6286,
	"./images/icons/icon-arrow-up-mineshaft.svg": 8123,
	"./images/icons/icon-back-to-top-m.svg": 4137,
	"./images/icons/icon-back-to-top.svg": 7552,
	"./images/icons/icon-bloodtest.svg": 6369,
	"./images/icons/icon-circle-calendar-blue.svg": 5149,
	"./images/icons/icon-circle-delay-blue-m.svg": 2286,
	"./images/icons/icon-circle-delay-blue.svg": 2296,
	"./images/icons/icon-circle-dmf.png": 4149,
	"./images/icons/icon-circle-graph-blue-m.svg": 3956,
	"./images/icons/icon-circle-graph-blue.svg": 7060,
	"./images/icons/icon-circle-mmf.png": 6986,
	"./images/icons/icon-circle-number-1-blue.svg": 8674,
	"./images/icons/icon-circle-number-2-blue.svg": 6866,
	"./images/icons/icon-circle-number-3-blue.svg": 3695,
	"./images/icons/icon-circle-patient-support-blue.svg": 5996,
	"./images/icons/icon-circle-prescription-blue.svg": 5820,
	"./images/icons/icon-circle-shield-blue.svg": 7282,
	"./images/icons/icon-circle-slow-blue-m.svg": 5658,
	"./images/icons/icon-circle-slow-blue.svg": 3940,
	"./images/icons/icon-close-blue.svg": 6868,
	"./images/icons/icon-close-white.svg": 6947,
	"./images/icons/icon-download-arrows-white-yellow.svg": 7065,
	"./images/icons/icon-download-white.svg": 9953,
	"./images/icons/icon-download.svg": 4548,
	"./images/icons/icon-facebook-black.svg": 3171,
	"./images/icons/icon-instagram-black.svg": 3213,
	"./images/icons/icon-map-pin.svg": 819,
	"./images/icons/icon-megaphone.svg": 9255,
	"./images/icons/icon-menu-blue.svg": 3094,
	"./images/icons/icon-open-quote-turbo.svg": 7890,
	"./images/icons/lockup-dosage.svg": 478,
	"./images/logos/logo-bafiertam-lockup.svg": 8418,
	"./images/logos/logo-banner-life-sciences.svg": 7702,
	"./images/page-heroes/faqs-desktop.png": 7594,
	"./images/page-heroes/faqs-desktop.webp": 2120,
	"./images/page-heroes/faqs-mobile.png": 6482,
	"./images/page-heroes/faqs-mobile.webp": 7449,
	"./images/page-heroes/news-events-desktop.png": 1931,
	"./images/page-heroes/news-events-desktop.webp": 4267,
	"./images/page-heroes/news-events-mobile.png": 9068,
	"./images/page-heroes/news-events-mobile.webp": 2720,
	"./images/page-heroes/patient-experiences-desktop.png": 5727,
	"./images/page-heroes/patient-experiences-desktop.webp": 7195,
	"./images/page-heroes/patient-experiences-mobile.png": 4354,
	"./images/page-heroes/patient-experiences-mobile.webp": 7126,
	"./images/page-heroes/recursos-desktop.png": 4599,
	"./images/page-heroes/recursos-desktop.webp": 5153,
	"./images/page-heroes/recursos-mobile.png": 9706,
	"./images/page-heroes/recursos-mobile.webp": 6306,
	"./images/page-heroes/resources-desktop.png": 8170,
	"./images/page-heroes/resources-desktop.webp": 6641,
	"./images/page-heroes/resources-mobile.png": 9459,
	"./images/page-heroes/resources-mobile.webp": 871,
	"./images/page-heroes/starting-switching-desktop.png": 4828,
	"./images/page-heroes/starting-switching-desktop.webp": 1477,
	"./images/page-heroes/starting-switching-mobile.png": 2010,
	"./images/page-heroes/starting-switching-mobile.webp": 6141,
	"./images/page-heroes/support-savings-desktop.png": 4430,
	"./images/page-heroes/support-savings-desktop.webp": 1569,
	"./images/page-heroes/support-savings-mobile.png": 7517,
	"./images/page-heroes/support-savings-mobile.webp": 6355,
	"./images/page-heroes/talking-to-your-doctor-desktop.png": 3138,
	"./images/page-heroes/talking-to-your-doctor-desktop.webp": 9377,
	"./images/page-heroes/talking-to-your-doctor-mobile.png": 7276,
	"./images/page-heroes/talking-to-your-doctor-mobile.webp": 6831,
	"./images/page-heroes/why-bafiertam-desktop.png": 5977,
	"./images/page-heroes/why-bafiertam-desktop.webp": 7997,
	"./images/page-heroes/why-bafiertam-mobile.png": 6613,
	"./images/page-heroes/why-bafiertam-mobile.webp": 827,
	"./images/pages/talking-to-your-doctor/get-the-guide.png": 3278,
	"./images/resources/img-0-copay-program.png": 6234,
	"./images/resources/img-0-copay-program.webp": 9227,
	"./images/resources/img-count-memories-esp.png": 1616,
	"./images/resources/img-count-memories-esp.webp": 2065,
	"./images/resources/img-count-memories.png": 5094,
	"./images/resources/img-count-memories.webp": 2030,
	"./images/resources/img-patient-consent-portal.png": 4615,
	"./images/resources/img-patient-consent-portal.webp": 5970,
	"./images/resources/img-patient-consideration-kit-esp.png": 4860,
	"./images/resources/img-patient-consideration-kit-esp.webp": 6959,
	"./images/resources/img-patient-consideration-kit-updated.webp": 2501,
	"./images/resources/img-patient-consideration-kit.png": 5700,
	"./images/resources/img-patient-consideration-kit.webp": 6732,
	"./images/resources/img-patient-information.png": 3581,
	"./images/resources/img-patient-information.webp": 3043,
	"./images/resources/img-prescribing-information.png": 7993,
	"./images/resources/img-prescribing-information.webp": 5453,
	"./images/resources/lockup-caregiver-action.png": 9308,
	"./images/resources/lockup-caregiver-action.webp": 1553,
	"./images/resources/lockup-caregiving.png": 6119,
	"./images/resources/lockup-caregiving.webp": 6679,
	"./images/resources/lockup-nmss.png": 3511,
	"./images/resources/lockup-nmss.webp": 8981,
	"./images/social/social-bg-m.svg": 5361,
	"./images/social/social-bg.svg": 5326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1844;